import { useMemo, useState } from "react";
import { works } from "@/mocks/doujin";

const filterTabs = ["全部", "漫画本", "插画集", "四格漫", "条漫", "短篇集", "画集打包"];

export default function Works() {
  const [active, setActive] = useState("全部");
  const list = useMemo(
    () => (active === "全部" ? works : works.filter((w) => w.category === active)),
    [active],
  );

  return (
    <section
      id="works"
      className="scroll-mt-20 bg-background-100 py-16 md:py-24"
    >
      <div className="mx-auto w-full max-w-7xl px-4 md:px-6">
        <div className="flex flex-col items-start justify-between gap-4 md:flex-row md:items-end">
          <div>
            <span className="text-sm font-medium tracking-wide text-secondary-600">热门推荐</span>
            <h2 className="font-heading mt-2 text-2xl text-foreground-950 md:text-4xl">
              本周人气同人作品
            </h2>
            <p className="mt-3 max-w-xl text-sm leading-relaxed text-foreground-600 md:text-base">
              精选读者最爱的漫画本、插画集与条漫佳作，点击分类快速切换。
            </p>
          </div>
        </div>

        <div className="mt-8 flex flex-wrap gap-2">
          {filterTabs.map((tab) => (
            <button
              key={tab}
              onClick={() => setActive(tab)}
              className={`cursor-pointer whitespace-nowrap rounded-full px-4 py-2 text-sm transition-colors ${
                active === tab
                  ? "bg-primary-500 text-background-50"
                  : "bg-background-50 text-foreground-600 hover:bg-primary-100 hover:text-primary-700"
              }`}
            >
              {tab}
            </button>
          ))}
        </div>

        <div className="mt-8 grid grid-cols-1 gap-5 sm:grid-cols-2 lg:grid-cols-4">
          {list.map((w) => (
            <article
              key={w.id}
              className="group flex cursor-pointer flex-col overflow-hidden rounded-2xl border border-background-200 bg-background-50"
            >
              <div className="relative h-60 w-full overflow-hidden md:h-64">
                <img
                  src={w.image}
                  alt={`${w.title} - ${w.author}同人作品封面`}
                  className="h-full w-full object-cover object-top transition-transform duration-500 group-hover:scale-105"
                />
                <span className="absolute left-3 top-3 rounded-full bg-accent-500 px-3 py-1 text-xs font-medium text-background-50">
                  {w.category}
                </span>
                <button className="absolute bottom-3 right-3 flex h-9 w-9 items-center justify-center rounded-full bg-background-50/90 text-primary-600 opacity-0 transition-opacity group-hover:opacity-100 cursor-pointer">
                  <i className="ri-heart-3-line" />
                </button>
              </div>
              <div className="flex flex-1 flex-col p-4 md:p-5">
                <h3 className="font-heading text-base text-foreground-950 md:text-lg">{w.title}</h3>
                <p className="mt-0.5 text-xs text-foreground-500">@{w.author}</p>
                <p className="mt-2 line-clamp-2 flex-1 text-xs leading-relaxed text-foreground-600 md:text-sm">
                  {w.summary}
                </p>
                <div className="mt-3 flex flex-wrap gap-1.5">
                  {w.tags.map((t) => (
                    <span
                      key={t}
                      className="rounded-full bg-secondary-100 px-2.5 py-0.5 text-xs text-secondary-800"
                    >
                      {t}
                    </span>
                  ))}
                </div>
                <div className="mt-4 flex items-center justify-between border-t border-background-200 pt-3 text-xs text-foreground-500">
                  <span>
                    <i className="ri-file-list-3-line mr-1" />
                    {w.pages} 页
                  </span>
                  <span>
                    <i className="ri-heart-3-fill mr-1 text-accent-500" />
                    {w.likes.toLocaleString()}
                  </span>
                </div>
              </div>
            </article>
          ))}
        </div>
      </div>
    </section>
  );
}